import { useAuth } from '@clerk/clerk-react';
import { useSignInModalContext } from '../contexts/SignInModalContext';

export interface ClerkAuthFacade {
  isAuthLoaded: boolean;
  isSignedIn: boolean;
  openSignIn: (options?: { returnUrl?: string }) => void;
}

export function useClerkAuth(): ClerkAuthFacade {
  const { isLoaded: isAuthLoaded, isSignedIn } = useAuth();
  const { openSignInModal } = useSignInModalContext();

  return {
    isAuthLoaded,
    isSignedIn: !!isSignedIn,
    openSignIn: (options?: { returnUrl?: string }) => {
      const returnUrl = (() => {
        if (options?.returnUrl) return options.returnUrl;

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('replay', '1');
          return url.toString();
        } catch {
          return undefined;
        }
      })();

      openSignInModal({
        returnUrl,
        afterSignInUrl: returnUrl,
        afterSignUpUrl: returnUrl,
      });
    },
  };
}
